
import { Movie } from "@/types/movie";

/**
 * Convert database row to Movie object
 * UPDATED: Enhanced to handle metadata from the new get_user_movies_with_metadata RPC
 */
export function fromDbRow(row: any): Movie {
  return {
    tmdbId: row.tmdb_id,
    title: row.title || 'Unknown Title',
    director: row.director || 'Unknown Director', 
    year: row.year || 0,
    tags: row.tags || [],
    favorite: row.favorite || false,
    planToWatch: row.plan_to_watch || false,
    posterPath: row.poster_path,
    backdropPath: row.backdrop_path,
    overview: row.overview,
    // Enhanced metadata fields - these may come from the enhanced RPC query
    releaseDate: row.release_date,
    voteAverage: row.vote_average,
    runtime: row.runtime,
    popularity: row.popularity,
    genres: row.genres || row.tags || [], // Prefer genres, fallback to tags
    // Always mark database records with source
    source: 'database'
  };
}
